<template>
  <div
    class="fixed bottom-1 md:bottom-8 right-8 z-[1000] rounded-2xl p-[2px] [background:linear-gradient(170deg,#FFFFFF_-15.61%,#878383_121.33%)] hover:[background:linear-gradient(170deg,#F1FF9D_-24.23%,#BDBDBD_83.68%)]"
  >
    <Button
      class="w-[174px] h-[33px] rounded-2xl !bg-[#3d3c3c] !text-white !border-0 shadow-none flex justify-center items-center"
      aria-label="Открыть чат поддержки"
      @click="toggleChat"
    >
      <span class="text-sm font-semibold">Чат поддержки</span>
      <img
        src="@/assets/support-chat/OpenChat.svg"
        class="ml-2"
        alt="chat"
      />
    </Button>
  </div>
</template>

<script setup>
import Button from 'primevue/button';
import { defineProps } from 'vue';

defineProps({
  toggleChat: Function,
  hasUnreadMessages: Boolean
});
</script>
